import { render, staticRenderFns } from "./backupCopy.vue?vue&type=template&id=49e1f21e&scoped=true&"
import script from "./backupCopy.vue?vue&type=script&lang=js&"
export * from "./backupCopy.vue?vue&type=script&lang=js&"
import style0 from "./backupCopy.vue?vue&type=style&index=0&id=49e1f21e&prod&scoped=true&lang=css&"
import style1 from "./backupCopy.vue?vue&type=style&index=1&id=49e1f21e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e1f21e",
  null
  
)

export default component.exports